import type { TypeNewCoworkerAction } from 'types/actionPlan';
import { useTranslation } from 'react-i18next';
import type { TypeContract } from 'types/scenario';
import { getShortCC } from 'utils/text';
import Text from '@ingka/text';
import classes from '../ActionTable.module.scss';
import { displayActionHours } from './utils';

const NewCoworkerAction = ({ action, contractType }:{ action: TypeNewCoworkerAction, contractType: TypeContract }) => {
    const { t } = useTranslation();

    return (
        <div className={classes['details-changes']}>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-dummy-created-header"
                >
                    {t('actionPlan.table.coworker_created')}
                </Text>
            </div>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-dummy-hours-header"
                >
                    {t('globals.labels.contract_hours')}
                </Text>
                <Text
                    data-testid="action-plan-dummy-hours-change"
                >
                    {displayActionHours(action.hours, t)}
                </Text>
            </div>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-dummy-cc-header"
                >
                    {t('actionPlan.table.cost_center')}
                </Text>
                <Text
                    data-testid="action-plan-dummy-cc-change"
                >
                    {`CC${getShortCC(action.costCentre)}`}
                </Text>
            </div>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-dummy-contract-type-header"
                >
                    {t('actionPlan.table.contract_type')}
                </Text>
                <Text data-testid="action-plan-dummy-contract-type-change">
                    {t(contractType)}
                </Text>
            </div>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-dummy-employment-type-header"
                >
                    {t('EMPLOYMENT_TYPE')}
                </Text>
                <Text
                    data-testid="action-plan-dummy-employment-type-change"
                >
                    {t(action.employmentType)}
                </Text>
            </div>
        </div>
    );
};

export default NewCoworkerAction;
